import { RouteObject } from 'react-router-dom'
import { RouteNotFound } from './RouteNotFound'
import { COMMUNITY_PATHS } from './paths/community'
import { TASKS_PATHS } from './paths/tasks'
import { FILES_PATHS } from './paths/files'
import { ACTIVITY_PATHS } from './paths/activity'
import { RECORD_PATHS } from './paths/record'
import { CALLS_PATHS } from './paths/calls'
import { NOTES_PATHS } from './paths/notes'
import { ACCOUNT_SETTINGS } from './paths/accountSettings'
import { DefaultPath } from './DefaultPath'
import { ADMIN_SETTINGS } from './paths/adminSettings'

export const ROUTES: RouteObject[] = [
  {
    path: '/',
    element: <DefaultPath />,
    errorElement: <RouteNotFound />,
    children: [
      ...COMMUNITY_PATHS,
      ...TASKS_PATHS,
      ...ACTIVITY_PATHS,
      ...FILES_PATHS,
      ...RECORD_PATHS,
      ...CALLS_PATHS,
      ...NOTES_PATHS,
      ...ACCOUNT_SETTINGS,
      ...ADMIN_SETTINGS,
    ],
  },
]
